import actions from '../action/group'
import CONSTANT from '../constant/group'
import _ from 'underscore'

const hotActiveList = []
const hotActivePage = {
  total: 0,
  pageSize: 10,
  pageNum: 1,
}
export default {
  actions,
  state: {

    groupInfo: {},
    moreGroup: [],
    groupUser: {},
    hotActiveList,
    hotActivePage,
  },
  mutations: {
    [CONSTANT.ITEM_GET_GROUP_INFO_SUCCESS](state, data) {
      return state.groupInfo = data
    },
    [CONSTANT.ITEM_GET_GROUP_INFO_ERROR](state, data) {
      return state.groupInfo = {}
    },
    [CONSTANT.ITEM_GET_HOT_ACTIVE_GROUP_LIST_SUCCESS](state, {
      list,
      page
    }) {
      state.hotActiveList = [...state.hotActiveList.concat(list)]
      state.hotActivePage = page
    },
    [CONSTANT.ITEM_GET_HOT_ACTIVE_GROUP_LIST_ERROR](state, info) {
      state.hotActiveList = []
      state.hotActivePage = {
        total: 0,
        pageSize: 10,
        pageNum: 1,
      }
    },
    [CONSTANT.ITEM_GETMOREGROUP_SUCCESS] (state, data) {
      state.moreGroup = data.list
    },
    [CONSTANT.ITEM_GETMOREGROUP_ERROR] (state, e) {
      state.moreGroup = []
    },
    [CONSTANT.ITEM_GET_GROUP_USER_SUCCESS] (state, data) {
      state.groupUser = data
    },
    [CONSTANT.ITEM_GET_GROUP_USER_ERROR] (state, e) {
      state.groupUser = {}
    }
  }
}
